import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { SUPPORTED_LANGUAGES } from '../i18n';

const LanguageSwitcher = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language || 'en';

  const onChange = (e) => {
    const next = e.target.value;
    i18n.changeLanguage(next);
    try { localStorage.setItem('bge_lang', next); } catch {}
  };

  return (
    <div className={`relative inline-flex items-center ${className}`} data-testid="language-switcher">
      <Globe className="w-4 h-4 absolute left-3 text-text-secondary pointer-events-none" />
      <select
        value={current}
        onChange={onChange}
        className="pl-9 pr-3 py-2 h-9 rounded-full border border-slate-200 bg-white text-sm focus:ring-2 focus:ring-primary/20 focus:border-primary appearance-none cursor-pointer"
        data-testid="language-select"
        aria-label="Language"
      >
        {SUPPORTED_LANGUAGES.map(l => (
          <option key={l.code} value={l.code}>{l.flag} {l.label}</option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
